export const queryKeys = {
  allFunds: ["allFunds"], // כל הקרנות ממקורות GEMELNET, PENSIANET, INSURANCENET
  users: ["users"], // רשימת המשתמשים (כמערך)
  userById: (id: number) => ["user", id], // משתמש לפי ID
 
  deals: ["deals"],
  dealById: (id: number) => ["deal", id],

  contactComments: ["contactComments"],
  contactCommentById: (id: number) => ["contactComment", id],

  payments: ["payments"],
  paymentById: (id: number) => ["payment", id],

  meetings: ["meetings"],
  meetingById: (id: number) => ["meeting", id],

  clientUsers: ["clientUsers"],
  clientUserById: (id: number) => ["clientUser", id],

  contacts: ["contacts"],
  contactById: (id: number) => ["contact", id],

  userPrivacy: ["userPrivacys"], // רשימת נתוני פרטיות
  userPrivacyById: (id: number) => ["userPrivacy", id], // נתון פרטני לפי ID
  mimshak: ["mimshak"], // מפתח השאילתה עבור משתמשים
  fundsByIds: ["fundsByIds"],
  fundsById: ["fundsById"],
  fundsFacets: ["fundsFacets"],
  securePillowFeature: ["securePillowFeature"],
  mimshakDatalatestRecords: (userId: number) => [
    "mimshakDatalatestRecords",
    userId,
  ],
  mimshakDataByPeriod: (userId: number, period: string) => [
    "mimshakDataByPeriod",
    userId,
    period,
  ],
  mimshakPreAdviceLatestRecords: ["mimshakPreAdviceLatestRecords"],
  mimshakPreAdviceDataByPeriod: ["mimshakPreAdviceDataByPeriod"],
  fundsYieldsByIds: ["fundsYieldsByIds"],
  topFundsByCriteria: ["topFundsByCriteria"],
  // ✅ הוספת מפתח חדש לפי userId
  reportedPeriods: (userId: number) => ["reportedPeriods", userId],
  preAdviceReportedPeriods: (userId: number) => ["preAdviceReportedPeriods", userId],
  preadviceTasks: ["preadviceTasks"], // רשימת המשתמשים (כמערך)
  preadviceTasksById: (id: string) => ["preadviceTasks", id], // משתמש לפי ID
  
  families: ["families"],
  familyById: (id: number) => ["family", id],
  familyByContactId: (contactId: number) => ["familiesByContact", contactId],

  familyMembersBase: ["familyMembers"], // מפתח בסיסי עבור hooks כללים
  familyMemberById: (id: number) => ["familyMember", id],
  familyMembers: (familyId: number) => ["familyMembers", familyId],
 
  familyExpenses: ["familyExpenses"], // מפתח השאילתה עבור הוצאות לפי משפחה
  userExpenses: ["userExpenses"], // מפתח השאילתה עבור הוצאות לפי משתמש
  userExpense: ["userExpense"], // מפתח השאילתה עבור הוצאה בודדת
  userAssetsPlan: (id: number) => ["userAssetsPlan", id],
  userAssetsPlans: (userId: number) => ["userAssetsPlans", userId],
  familyAssetsPlans: (familyId: number) => ["familyAssetsPlans", familyId],
  userAssetActualsByPlan: (planId: number) => ["userAssetActuals", planId],

  taskBoards: ["taskBoards"], // רשימת לוחות משימות
  taskBoardById: (id: number) => ["taskBoard", id], // לוח משימות לפי ID
  taskListsByBoard: (boardId: number | undefined) => ["taskLists", boardId],
  agentProducerCodes: ["agentProducerCodes"],


};
